/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_password = /** @type {(inputs: {}) => string} */ () => {
	return `Heslo`
};

const da_password = /** @type {(inputs: {}) => string} */ () => {
	return `Adgangskode`
};

const de_password = /** @type {(inputs: {}) => string} */ () => {
	return `Passwort`
};

const en_password = /** @type {(inputs: {}) => string} */ () => {
	return `Password`
};

const es_password = /** @type {(inputs: {}) => string} */ () => {
	return `Contraseña`
};

const fr_password = /** @type {(inputs: {}) => string} */ () => {
	return `Mot de passe`
};

const hu_password = /** @type {(inputs: {}) => string} */ () => {
	return `Jelszó`
};

const it_password = /** @type {(inputs: {}) => string} */ () => {
	return `Password`
};

const nl_password = /** @type {(inputs: {}) => string} */ () => {
	return `Wachtwoord`
};

const pl_password = /** @type {(inputs: {}) => string} */ () => {
	return `Hasło`
};

const pt_password = /** @type {(inputs: {}) => string} */ () => {
	return `Senha`
};

const sv_password = /** @type {(inputs: {}) => string} */ () => {
	return `Lösenord`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("password", locale)
	if (locale === "cs") return cs_password(inputs)
	if (locale === "da") return da_password(inputs)
	if (locale === "de") return de_password(inputs)
	if (locale === "en") return en_password(inputs)
	if (locale === "es") return es_password(inputs)
	if (locale === "fr") return fr_password(inputs)
	if (locale === "hu") return hu_password(inputs)
	if (locale === "it") return it_password(inputs)
	if (locale === "nl") return nl_password(inputs)
	if (locale === "pl") return pl_password(inputs)
	if (locale === "pt") return pt_password(inputs)
	return sv_password(inputs)
};